import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MonthPickerDOS {
  private _panelClassSubject = new BehaviorSubject<string>('custom-datepicker current-year');
  readonly panelClass$ = this._panelClassSubject.asObservable();

  private _selectedReleaseMonthSubject = new BehaviorSubject<boolean>(null);
  readonly selectedReleaseMonth$ = this._selectedReleaseMonthSubject.asObservable();

  changePanelClass(panelClass: string): void {
    this._panelClassSubject.next(panelClass);
  }

  changeSelectedReleaseMonth(newValue: boolean): void {
    this._selectedReleaseMonthSubject.next(newValue);
  }
}
